<template>
    <div>
        <div class="uk-sticky fixed-navbar" uk-sticky="animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky uk-background-muted uk-inverse uk-light; cls-inactive: uk-navbar-initial uk-light; top: 80" v-bind:class="{ 'uk-background-muted' : $route.path!='/'}">

            <router-link class="uk-logo uk-logo-mobile nav-mobile-visible" to="/" v-if="!state.api.search.active"></router-link>
            <a class="uk-icon uk-close nav-mobile-visible" :uk-icon="mobileMenu ? 'close' : 'menu'" @click.stop="toggleMenu"></a>

            <div class="">
                <nav class="uk-navbar-container uk-navbar-transparent uk-light" uk-navbar>

                    <div class="uk-navbar-left uk-width-expand nav-mobile-hidden" v-if="!state.api.search.active">
                        <router-link class="uk-logo uk-logo-desktop" to="/" v-if="!state.api.search.active"></router-link>
                    </div>

                    <div class="uk-navbar-right uk-margin-right " v-if="!state.api.search.active">
                        <ul class="uk-navbar-nav">
                            
                            <router-link custom :to="nav.Link" v-for="nav in state.api.nav" v-slot="{ href, isActive, navigate}">
                                <li class="nav-mobile-hidden" :class="{ 'uk-active': isActive }">
                                    <a :href="href" @click="navigate">{{nav.MenuTitle}}</a>
                                    <div class="uk-navbar-dropdown" v-if="nav.Children.length">
                                        <ul class="uk-nav uk-navbar-dropdown-nav">
                                            <router-link custom :to="child.Link" v-for="child in nav.Children" v-slot="{ href, isActive, navigate}">
                                                <li :class="{ 'uk-active': isActive }">
                                                    <a :href="href" @click="navigate">{{child.MenuTitle}}</a>
                                                </li>
                                            </router-link>
                                        </ul>
                                    </div>
                                </li>
                            </router-link>
                            
                            <a class="uk-navbar-toggle" uk-search-icon="ratio: 1.5" @click.stop="toggleSearch()"></a>
                        </ul>
                    </div>

                    <div class="nav-overlay uk-navbar-left uk-flex-1 nav-search" v-if="state.api.search.active">

                        <div class="uk-navbar-item uk-width-expand uk-margin-small-left uk-margin-small-right">
                            <form class="uk-search uk-search-navbar uk-width-1-1" v-on:submit.prevent>
                                <input class="uk-search-input" type="search" placeholder="Search..." autofocus v-model="state.api.search.query" ref="searchField">
                            </form>
                        </div>

                        <a class="uk-search-close uk-navbar-toggle uk-margin-right" uk-close @click.stop="toggleSearch()"></a>

                    </div>

                </nav>

                <ul class="uk-flex-center subnav uk-light" uk-tab v-if="state.api.subnav.length && !(state.api.search.active && state.api.search.query)">
                    <router-link custom :to="nav.link" v-for="nav in state.api.subnav" v-slot="{ href, navigate, isExactActive }">
                        <li :class="{ 'uk-active': isExactActive }">
                            <a :href="href" @click="navigate">{{nav.title}}</a>
                        </li>
                    </router-link>
                </ul>
            </div>

            <div class="mobile-nav" v-if="mobileMenu">
                <div class="uk-flex uk-flex-column uk-flex-center">
                    <ul class="uk-nav uk-nav-default" @click="toggleMenu()">
                        <router-link custom :to="nav.Link" v-for="nav in state.api.nav" v-slot="{ href, isActive, navigate}">
                            <li :class="{ 'uk-active': isActive }">
                                <a :href="href" @click="navigate">{{nav.MenuTitle}}</a>
                            </li>
                        </router-link>
                    </ul>

                    <div class="uk-text-center ">

                        <FollowLinks />

                        <router-link to="/donate" class="uk-button theme-button button-green uk-margin-large-top">Donate</router-link>
                    </div>
                </div>
            </div>

        </div>

        <!--  MOBILE SUBNAV -->
        <div class="nav-mobile-visible uk-position-fixed uk-position-top subnav-mobile" v-if="state.api.subnav && state.api.subnav.length && !state.api.search.active && !state.api.search.query">
            <button class="uk-button uk-button-secondary" type="button"><span class="uk-icon" uk-icon="chevron-down"></span></button>
            <div uk-dropdown>
                <ul class="uk-nav uk-dropdown-nav">
                    <router-link custom :to="nav.link" v-for="nav in state.api.subnav" v-slot="{ href, isExactActive, navigate}">
                        <li :class="{ 'uk-active': isExactActive }">
                            <a :href="href" class="uk-width-1-1" @click="navigate">{{nav.title}}</a>
                        </li>
                    </router-link>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
export default {
	inject: [
        'state',
		'theme'
	],
	beforeMount() {
		this.state.api.getData("nav", "nav", '', "v2")
	},
	data() {
		return {
			mobileMenu: false
		}
	},
	methods: {
		toggleMenu() {
			this.mobileMenu = !this.mobileMenu
			this.mobileMenu ? document.body.classList.add('noscroll') : document.body.classList.remove('noscroll')
		},
        toggleSearch() {
            this.state.api.search.active=!this.state.api.search.active
            if(this.state.api.search.active) {
                this.$nextTick(function() {
                    this.$refs.searchField.focus()
                })
            }
        }
	}
};
</script>

<style scoped lang="scss">
$mobile-breakpoint: 1250px;

.nav-mobile-hidden {
    display: none;        
}

@media(max-width: $mobile-breakpoint) {
    .nav-mobile-visible {
        display: block;
    } 
    .uk-navbar-toggle {
        margin: 5px 55px 5px 5px;
        color: #FFF;
        // &.uk-icon > * {
        //     width: 30px;
        // }
    }
    .nav-search {
        z-index: 999999;
    }
}

@media(min-width: $mobile-breakpoint) {
    .nav-mobile-visible {
        display: none;
    }
    .nav-mobile-hidden {
        display: block;
    }
}

</style>